import React from "react";
import { Button, HStack, Text, Tooltip } from "@chakra-ui/react";

/**
 * A same-name/different-dob question, shown on the inbox entry.
 *
 * The fax filed normally in its own schema. Another schema in the clinic group
 * has a patient with the same name but a different date of birth — which may be
 * the same person recorded wrongly, or genuinely someone else. The system
 * refuses to guess, because guessing wrong files one patient's records onto
 * another's chart, and this database really does hold three different people
 * called "Li, Diego".
 *
 * Renders nothing when there is nothing to decide, so a clean inbox stays
 * clean.
 */
export const FaxPendingIdentity = ({ fax, onResolve }) => {
  const questions = fax?.pending_identity || [];
  if (!questions.length) return null;

  return (
    <>
      {questions.map((q) => (
        <HStack key={`${q.schema}-${q.row_id}`} spacing={2} mt={1}>
          <Tooltip label={q.reason || ""}>
            <Text
              fontSize="xs"
              color="orange.800"
              bg="orange.100"
              px={2}
              py={0.5}
              borderRadius="md"
            >
              ❓ {q.schema}: same name, dob {q.dob} vs {q.anchor_dob} — same
              patient?
            </Text>
          </Tooltip>
          <Button
            size="xs"
            colorScheme="green"
            onClick={() =>
              onResolve({ ...q, file_path: fax.file_path }, "confirm_identity")
            }
          >
            Yes, file it
          </Button>
          <Button
            size="xs"
            variant="ghost"
            onClick={() =>
              onResolve({ ...q, file_path: fax.file_path }, "reject_identity")
            }
          >
            No
          </Button>
        </HStack>
      ))}
    </>
  );
};

export default FaxPendingIdentity;
